import {
    GET_TARIFF_HEADS,
    GET_TARIFF_HEADS_SUCCESS,
    GET_TARIFF_HEADS_FAILURE,
    GET_TARIFF_HEADS_WITH_DETAILS,
    GET_TARIFF_HEADS_WITH_DETAILS_SUCCESS,
    GET_TARIFF_HEADS_WITH_DETAILS_FAILURE,
    GET_TARIFF_HEAD_DETAILS,
    GET_TARIFF_HEAD_DETAILS_SUCCESS,
    GET_TARIFF_HEAD_DETAILS_FAILURE,
    CREATE_TARIFF_HEAD,
    CREATE_TARIFF_HEAD_SUCCESS,
    CREATE_TARIFF_HEAD_FAILURE,
    UPDATE_TARIFF_HEAD,
    UPDATE_TARIFF_HEAD_SUCCESS,
    UPDATE_TARIFF_HEAD_FAILURE,
    UPDATE_TARIFF_HEAD_STATUS,
    UPDATE_TARIFF_HEAD_STATUS_SUCCESS,
    UPDATE_TARIFF_HEAD_STATUS_FAILURE,
    DELETE_TARIFF_HEAD,
    DELETE_TARIFF_HEAD_SUCCESS,
    DELETE_TARIFF_HEAD_FAILURE
} from '../../../actions/index.types';

const initialState = {
    // List
    tariffHeadsData: [],
    tariffHeadsPagination: null,
    loading: false,
    error: null,

    // List with Details (rates, meterSlabs, taxRule)
    tariffHeadsWithDetails: [],
    tariffHeadsWithDetailsLoading: false,
    tariffHeadsWithDetailsError: null,

    // Details
    tariffHeadDetails: null,
    detailsLoading: false,
    detailsError: null,

    // Create
    createLoading: false,
    createError: null,
    createSuccess: false,

    // Update
    updateLoading: false,
    updateError: null,
    updateSuccess: false,

    // Status Update
    statusLoading: false,
    statusError: null,
    statusSuccess: false,

    // Delete
    deleteLoading: false,
    deleteError: null,
    deleteSuccess: false
};

const TariffHeadReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get All Tariff Heads
        case GET_TARIFF_HEADS:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_TARIFF_HEADS_SUCCESS:
            return {
                ...state,
                loading: false,
                tariffHeadsData: action.data?.data || [],
                tariffHeadsPagination: action.data?.meta?.pagination || null,
                error: null
            };
        case GET_TARIFF_HEADS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.data
            };

        // Get Tariff Heads With Details
        case GET_TARIFF_HEADS_WITH_DETAILS:
            return {
                ...state,
                tariffHeadsWithDetailsLoading: true,
                tariffHeadsWithDetailsError: null
            };
        case GET_TARIFF_HEADS_WITH_DETAILS_SUCCESS:
            return {
                ...state,
                tariffHeadsWithDetailsLoading: false,
                tariffHeadsWithDetails: action.data?.data || [],
                tariffHeadsWithDetailsError: null
            };
        case GET_TARIFF_HEADS_WITH_DETAILS_FAILURE:
            return {
                ...state,
                tariffHeadsWithDetailsLoading: false,
                tariffHeadsWithDetailsError: action.data
            };

        // Get Tariff Head Details
        case GET_TARIFF_HEAD_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                detailsError: null
            };
        case GET_TARIFF_HEAD_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                tariffHeadDetails: action.data,
                detailsError: null
            };
        case GET_TARIFF_HEAD_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                detailsError: action.data
            };

        // Create Tariff Head
        case CREATE_TARIFF_HEAD:
            return {
                ...state,
                createLoading: true,
                createError: null,
                createSuccess: false
            };
        case CREATE_TARIFF_HEAD_SUCCESS:
            return {
                ...state,
                createLoading: false,
                createSuccess: true,
                createError: null
            };
        case CREATE_TARIFF_HEAD_FAILURE:
            return {
                ...state,
                createLoading: false,
                createError: action.data,
                createSuccess: false
            };

        // Update Tariff Head
        case UPDATE_TARIFF_HEAD:
            return {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: false
            };
        case UPDATE_TARIFF_HEAD_SUCCESS:
            return {
                ...state,
                updateLoading: false,
                updateSuccess: true,
                updateError: null
            };
        case UPDATE_TARIFF_HEAD_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action.data,
                updateSuccess: false
            };

        // Update Tariff Head Status
        case UPDATE_TARIFF_HEAD_STATUS:
            return {
                ...state,
                statusLoading: true,
                statusError: null,
                statusSuccess: false
            };
        case UPDATE_TARIFF_HEAD_STATUS_SUCCESS:
            return {
                ...state,
                statusLoading: false,
                statusSuccess: true,
                statusError: null
            };
        case UPDATE_TARIFF_HEAD_STATUS_FAILURE:
            return {
                ...state,
                statusLoading: false,
                statusError: action.data,
                statusSuccess: false
            };

        // Delete Tariff Head
        case DELETE_TARIFF_HEAD:
            return {
                ...state,
                deleteLoading: true,
                deleteError: null,
                deleteSuccess: false
            };
        case DELETE_TARIFF_HEAD_SUCCESS:
            return {
                ...state,
                deleteLoading: false,
                deleteSuccess: true,
                deleteError: null
            };
        case DELETE_TARIFF_HEAD_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                deleteError: action.data,
                deleteSuccess: false
            };

        default:
            return state;
    }
};

export default TariffHeadReducer;
